import ContactUs2Container from "../../../components/pages/other/ContactUs2";

const ContactUs2 = () => {
  return <ContactUs2Container />;
};

export default ContactUs2;
